import { useState } from 'react';
import { SCOPES } from '../utils/quiz.js';
import { track } from '../utils/tracking.js';
import { playClick } from '../utils/audio.js';

export default function HomeScreen({ onStart }) {
  const [scope, setScope] = useState('all');

  function handleStart() {
    playClick();
    track('quiz_started', { mode: 'capitals', scope });
    onStart('capitals', scope);
  }

  return (
    <div className="fade-in">
      <section className="home-hero">
        <p className="eyebrow fade-in delay-1">A quiz from OpenEd</p>
        <h1 className="fade-in delay-2">
          How well do you<br/>
          know <em>your</em> state capitals?
        </h1>
        <p className="lede fade-in delay-3">
          Ten questions. One country. Fifteen states where OpenEd families are already learning.
        </p>
      </section>

      <div className="scope-toggle fade-in delay-4">
        <span className="label">Scope</span>
        <div className="scope-pills">
          {Object.values(SCOPES).map(s => (
            <button
              key={s.id}
              className={`scope-pill ${scope === s.id ? 'active' : ''}`}
              onClick={() => { setScope(s.id); playClick(); }}
            >
              {s.name}
            </button>
          ))}
        </div>
      </div>

      <div className="home-cta fade-in delay-5">
        <button className="btn-start" onClick={handleStart}>
          Start the quiz →
        </button>
      </div>
    </div>
  );
}
